import { $qs, $qsa } from '../../../src/js/utils/QuerySelector';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

import Swiper, { Navigation, Autoplay, EffectFade, Pagination } from 'swiper';
// import Swiper and modules styles
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';	

gsap.registerPlugin(ScrollTrigger);


function swiperStatsMobile() {
    
    // init Swiper:
    var init = false;

    
        if ( ! init ) {
            init = true;

            const swiper = new Swiper('.swiper-slider-stats', {

                modules: [Navigation, Autoplay, EffectFade, Pagination],
                loop: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                slidesPerView: 1,
                slidesPerGroup: 1,
                slidesPerColumn: 1,
                spaceBetween: 0,
                speed: 1000,
                breakpoints: {                    
                },
            });
        }

}


function stats() {    
    if(window.innerWidth < 768) {
        swiperStatsMobile();
    }
}




export default stats;